export const routes = {
  home: () => "/",
  authLogin: () => "/auth/login",
  adminUsers: () => "/admin/users",
  adminUsersCreate: () => "/admin/users/create",
  adminUsersEdit: (userId: number) => `/admin/users/edit-${userId}`,
  adminUsersView: (userId: number) => `/admin/users/view-${userId}`,
  adminRoles: () => "/admin/roles",
  adminRolesCreate: () => "/admin/roles/create",
  adminRolesEdit: (roleId: number) => `/admin/roles/edit-${roleId}`,
  cms: () => "/cms",
  cmsAnnouncements: () => "/cms/announcements",
  cmsAnnouncementsCreate: () => "/cms/announcements/create",
  cmsAnnouncementsView: (announcementId: number) => `/cms/announcements/view-${announcementId}`,
  cmsReports: () => "/cms/reports",
  cmsReportsView: (reportId: number) => `/cms/reports/view-${reportId}`,
  cmsReportsEdit: (reportId: number) => `/cms/reports/edit-${reportId}`,
  cmsDrafts: () => "/cms/drafts",
  cmsDraftsEdit: (reportId: number) => `/cms/drafts/edit-${reportId}`,
  cmsMaintenanceReports: () => "/cms/maintenance-reports",
  cmsMaintenanceReportsCreate: () => `/cms/maintenance-reports/create`,
  cmsMaintenanceReportsView: (maintenanceIssueId: number) => `/cms/maintenance-reports/view-${maintenanceIssueId}`,
  cmsLostAndFounds: () => "/cms/lost-and-found",
  cmsLostAndFoundsCreate: () => "/cms/lost-and-found/create",
  cmsLostAndFoundsHandover: () => "/cms/lost-and-found/handover",
  cmsLostAndFoundView: (itemId: number) => `/cms/lost-and-found/view-${itemId}`,
  cmsContacts: () => "/cms/contacts",
  cmsContactsEdit: (contactId: number) => `/cms/contacts/edit-${contactId}`,
  cmsContactsCreate: () => `/cms/contacts/create`,
  cmsNotifications: () => "/cms/notifications",
  cmsNotificationsView: (notificationId: number) => `/cms/notifications/view-${notificationId}`,
  account: () => "/account",
  accountPrefrences: () => "/account/preferences",
  accountContactDetails: () => "/account/contact-details",
  accountChangePassword: () => "/account/change-password",
  accountSharedLinks: () => "/account/shared-links",
  sharedReport: (token: string) => `/public/shared-report-${token}`,
  forbidden: () => "/forbidden",
};
